import { styled } from '@mui/material';

import { DropOffIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';

import { SingleConfusionData } from '../../../../../../types';

import { SingleConfusion } from './components/SingleConfusion';
import { MissClicks } from './components/MissClicks';
import { DropOffs } from './components/DropOffs';

const ConfusionsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(5),
  justifyContent: 'center',
  alignItems: 'stretch',
  '@media screen and (min-width: 1024px)': {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
}));

export type MetricsProps = {
  confusion: SingleConfusionData;
  avgPageDuration: number;
};

export const Metrics = ({ confusion, avgPageDuration }: MetricsProps) => {
  const { t } = useI18n();
  const { missClicksRatio, dropOffsRatio, duration } = confusion;

  return (
    <ConfusionsContainer>
      {missClicksRatio >= 0.2 ? <MissClicks confusion={confusion} /> : null}
      {dropOffsRatio >= 0.2 ? <DropOffs confusion={confusion} /> : null}
      {duration > avgPageDuration * 1.5 ? (
        <SingleConfusion
          title="prototypes:report.confusions.metrics.long_dwell_time"
          icon={<DropOffIcon />}
          value={`${duration.toFixed(0)}s`}
          description={t(
            'prototypes:report.confusions.metrics.duration_description'
          )}
        />
      ) : null}
    </ConfusionsContainer>
  );
};
